import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import onClickOutside from 'react-onclickoutside';
import { Container, SnackbarButton, SnackbarText, SnackbarSpinner, transitionDuration } from './SnackbarStyledComponents';
import { snackbar as snackbarService } from '../../lib';
export var SNACKBAR_HEIGHT = 43;

var Snackbar = /*#__PURE__*/function (_Component) {
  _inherits(Snackbar, _Component);

  var _super = _createSuper(Snackbar);

  function Snackbar(props) {
    var _this;

    _classCallCheck(this, Snackbar);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "setAutoHideTimer", function () {
      var autoHideDuration = _this.props.autoHideDuration;

      if (autoHideDuration > 0) {
        _this.clearAutoHideTimer();

        _this.autoHideTimerId = setTimeout(_this.dismiss, autoHideDuration);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "clearAutoHideTimer", function () {
      if (_this.autoHideTimerId !== undefined) {
        _this.autoHideTimerId = clearTimeout(_this.autoHideTimerId);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "dismiss", function () {
      var open = _this.state.open;
      var onDismiss = _this.props.onDismiss;
      if (!open) return;

      _this.clearAutoHideTimer();

      _this.setState({
        open: false
      });

      window.setTimeout(onDismiss, transitionDuration);
    });

    _defineProperty(_assertThisInitialized(_this), "handleAction", function () {
      var _this$props = _this.props,
          preventActionDismiss = _this$props.preventActionDismiss,
          onAction = _this$props.onAction;
      var dismissPromise = new Promise(function (resolve) {
        return setTimeout(resolve, transitionDuration);
      });
      onAction(dismissPromise);
      if (!preventActionDismiss) _this.dismiss();
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickOutside", _this.dismiss);

    _this.state = {
      open: false
    };
    return _this;
  }

  _createClass(Snackbar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.service = snackbarService(this);
      this.service.dismissAll();
      this.setAutoHideTimer();
      window.setTimeout(function () {
        return _this2.setState({
          open: true
        });
      }, transitionDuration);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var pending = this.props.pending;
      if (prevProps.pending && pending) this.clearAutoHideTimer();else if (prevProps.pending && !pending) this.setAutoHideTimer();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.dismiss();
      this.service.deregister();
    }
  }, {
    key: "render",
    value: // eslint-disable-line react/sort-comp
    function render() {
      var _this$props2 = this.props,
          action = _this$props2.action,
          children = _this$props2.children,
          error = _this$props2.error,
          pending = _this$props2.pending,
          zIndex = _this$props2.zIndex;
      var open = this.state.open;
      return /*#__PURE__*/React.createElement(Container, {
        open: open,
        error: error,
        "data-testid": "snackbar-container",
        zIndex: zIndex
      }, /*#__PURE__*/React.createElement(SnackbarText, null, children), action && !pending && /*#__PURE__*/React.createElement(SnackbarButton, {
        onClick: this.handleAction,
        error: error,
        "data-testid": "snackbar-button"
      }, action), pending && /*#__PURE__*/React.createElement(SnackbarSpinner, {
        "data-testid": "snackbar-spinner"
      }));
    }
  }]);

  return Snackbar;
}(Component);

_defineProperty(Snackbar, "propTypes", {
  action: PropTypes.string,
  preventActionDismiss: PropTypes.bool,
  autoHideDuration: PropTypes.number,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  error: PropTypes.bool,
  onAction: PropTypes.func,
  onDismiss: PropTypes.func,
  pending: PropTypes.bool,
  zIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['auto'])])
});

_defineProperty(Snackbar, "defaultProps", {
  action: null,
  preventActionDismiss: false,
  autoHideDuration: 5000,
  error: false,
  onAction: function onAction() {
    return null;
  },
  onDismiss: function onDismiss() {
    return null;
  },
  pending: false,
  zIndex: 'auto'
});

export default onClickOutside(Snackbar);